
import { writable, readable, derived } from "svelte/store";


export const sessionId = writable('');

export const onboardingInfo = writable({});
